import { render, staticRenderFns } from "./view-footer.vue?vue&type=template&id=20644e45&scoped=true"
import script from "./view-footer.vue?vue&type=script&lang=js"
export * from "./view-footer.vue?vue&type=script&lang=js"
import style0 from "./view-footer.vue?vue&type=style&index=0&id=20644e45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20644e45",
  null
  
)

export default component.exports